import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-235">
      <div className="max-w-2xl mx-auto text-center" data-id="element-236">
        {/* Shield icon */}
        <div className="text-8xl mb-6" data-id="element-237">🛡️</div>

        <h2 className="text-3xl sm:text-4xl font-black text-[#00E68A] mb-4" data-id="element-238">
          GARANTÍA PROFEPACK — 7 DÍAS
        </h2>

        <div className="bg-[#0a100d] border-2 border-white/30 rounded-2xl p-8 mb-6" data-id="element-239">
          <p className="text-white text-lg mb-4 leading-relaxed" data-id="element-240">
            Abrís los 12 tomos. Revisás los 6 bonos. Los usás en el aula si
            querés.
          </p>
          <p className="text-white text-lg mb-6 leading-relaxed" data-id="element-241">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#00E68A] text-3xl font-black mb-4" data-id="element-242">
            Te devolvemos el 100%.
          </p>
          <p className="text-white text-xl font-bold" data-id="element-243">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-gray-400 text-sm leading-relaxed mb-2" data-id="element-244">
          La confianza que tenemos en PROFEPACK nos permite ofrecerte eso.
          <br data-id="element-245" />
          Más de 3.000 docentes de Lengua y Literatura ya lo saben.
        </p>
        <p className="text-[#00E68A] text-sm font-bold" data-id="element-246">
          La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}